import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  width: 100vw;
  min-height: 100vh;
  flex-direction: column;
  align-items: center;
  background: url('../../images/background-login.png');
  z-index: 1;
  background-size: cover; /* Para ajustar o tamanho da imagem */
  background-position: center; /* Para centralizar a imagem */
  /* background: linear-gradient(to right, #a68a64, #edf2f4); */
  letter-spacing: 10px;
`;

export const Logo = styled.img`
  margin: 80px auto 20px auto;
  margin-bottom: 20px;
  width: 250px;
`;

export const Box = styled.div`
  margin: 0 auto;
  width: 70%;
  max-width: 700px;
  background-color: #f1f1f1;
  height: 400px;
  border-radius: 10px;
  box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.5);
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center; /* Centraliza verticalmente */
  height: 100%; /* Para garantir que o container ocupe toda a altura do Box */
`;

export const Input = styled.input`
  color: black;
  width: 70%;
  margin-bottom: 2rem;
  padding: 0.5rem;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 1rem;
`;

export const ErrorMessage = styled.p`
  text-transform: uppercase;
  letter-spacing: 2px;
  margin-top: -15px;
  font-size: 0.8rem;
  font-family: 'Apple Color Emoji', 'Segoe UI Emoji', 'NotoColorEmoji',
    'Segoe UI Symbol', 'Android Emoji', 'EmojiSymbols';
  color: red;
  margin-bottom: 15px;
  font-weight: 600;
  /* [28/10] Saiu a animacao - ela piscava a mensagem entre vermelho escuro e vermelho,
     infinitamente. Com o botao "Encerrar sessao e entrar" logo abaixo, o texto deixou de
     ser so um aviso e passou a ser algo para LER antes de decidir - e texto que pisca
     atrapalha ler. O vermelho, a caixa alta e o negrito ja dao o destaque. */
`;

/* [28/10] O "Encerrar sessao e entrar".
   NAO reusa o Button: aquele tem width 25% e font-size 16pt, feitos para a palavra
   "Login" - um rotulo de quatro palavras quebra em tres linhas e vira um bloco maior
   que o proprio formulario. Aqui a largura acompanha o texto, a fonte e menor e o
   nowrap garante uma linha so.
   E e visualmente SECUNDARIO - contorno em vez de preenchido -, porque a acao comum
   continua sendo Login: quem chegou aqui por engano nao deve ser puxado para a acao
   que derruba a sessao de outro dispositivo. */
export const ButtonSecundario = styled.button`
  color: #5d3b2b;
  font-size: 10pt;
  background-color: transparent;
  border: 1px solid #5d3b2b;
  padding: 6px 14px;
  border-radius: 8px;
  cursor: pointer;
  margin-bottom: 14px;
  font-weight: 600;
  letter-spacing: 1px;
  white-space: nowrap;
  transition: background-color 0.3s ease, color 0.3s ease;

  &:hover {
    background-color: #5d3b2b;
    color: white;
  }
`;

export const Button = styled.button`
  color: white;
  font-size: 16pt;
  background-color: #5d3b2b;
  padding: 7px;
  border-radius: 10px;
  cursor: pointer;
  width: 25%;
  font-weight: bold;
  letter-spacing: 2px;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.5);
  transition: background-color 0.3s ease; /* Adicionando uma transição suave */

  &:hover {
    background-color: #491a08; /* Mudança de cor quando em hover */
  }
`;
